import React from 'react';
import Button from '../../Forms/Button';

interface CreditNoteActionsProps {
    stamping: boolean;
    validRequested: boolean;
    totalOverflow: boolean;
    relatedTotal: number;
    total: number;
    // Emitters
    onClear: () => void;
    onSubmit: () => void;
}

function CreditNoteActions({ stamping, validRequested, totalOverflow, relatedTotal, total, onClear, onSubmit }: CreditNoteActionsProps) {
    return (
        <div className="actions">
            {
                stamping ?
                    <p className="message success">
                        <span className="">
                            Facturando, espere...
                        </span>
                    </p>
                    : (validRequested ?
                        <p className="message error">
                            <span className="error">
                                Algunos campos faltan de llenarse o contienen errores
                            </span>
                        </p>
                        : (
                            !!relatedTotal && totalOverflow ?
                                <p className="message error">
                                    <span className="error">
                                        El total de la nota de credito excede el total de la factura original
                                    </span>
                                </p>

                                :
                                ''))
            }
            <Button secondary={true} handleClick={onClear}>
                <span>
                    Limpiar
                </span>
            </Button>
            <Button primary={true} handleClick={onSubmit} disabled={totalOverflow || !total}>
                <span>
                    Emitir nota de crédito
                </span>
            </Button>
        </div>
    )
}

export default CreditNoteActions;
